export default "__VITE_ASSET__CtvUwm8W__"